import {
  BaseGrid,
  BaseGridItem,
} from '@awaze/design-system.components.base-grid'
import { Container } from '@awaze/design-system.components.container'
import { Text } from '@awaze/design-system.components.text'
import BlogTags from './BlogTags'
import { BlogTag } from './mapBlogTag'

export interface BlogTagListModuleProps {
  title?: string
  tags: BlogTag[]
}

export const BlogTagListModule: React.FC<BlogTagListModuleProps> = ({
  title,
  tags,
}) => (
  <div style={{ padding: '64px 16px' }}>
    <Container>
      <BaseGrid flush>
        <BaseGridItem columns={12} style={{ textAlign: 'center' }}>
          <Text as="h3" sizes={400} mb={0}>
            {title}
          </Text>
          <BlogTags tags={tags} center />
        </BaseGridItem>
      </BaseGrid>
    </Container>
  </div>
)
